import { Col, Table } from 'antd';


const DocEventView = (props) => {
  const { doc_event = [{ annotations: {} }], sentences } = props;
  return <>
    <Col span={10} style={{
      height: '100%',
      overflow: 'auto'
    }}><div>{sentences.map(({ id, content }) => <p
      id={`sentence${id}`}
      key={id}
    >{content}</p>)}</div></Col>
    <Col span={14} style={{
      height: '100%',
      overflow: 'auto'
    }}><Table dataSource={Object.entries({ '类型': '灾难', ...doc_event[0].annotations })}>
        <Table.Column title="事件属性" dataIndex={0} key="age" width={128} />
        <Table.Column title="属性值" dataIndex={1} key="address" />
      </Table></Col>
  </>
}
export default DocEventView